import EventEmitter from 'events';

class Device extends EventEmitter {
	constructor(deviceInfo) {
		super();

		Object.assign(this, {
			deviceId: deviceInfo.deviceId,
			groupId: deviceInfo.groupId,
			capabilities: deviceInfo.getCapabilities ? deviceInfo.getCapabilities() : {},
			kind: deviceInfo.kind,
			label: deviceInfo.label,
			_device: deviceInfo,
		});
	}

	serialize() {
		const settings = this._device.getSettings ? this._device.getSettings() : {};
		return {
			label: this.label,
			...settings,
		};
	}
}

export default Device;
